import script from "./EditGroupModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./EditGroupModal.vue?vue&type=script&lang=ts&setup=true"

import "./EditGroupModal.vue?vue&type=style&index=0&id=ba2c12a8&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ba2c12a8"]])

export default __exports__